import "../assets/css/normalize.css";
import "../assets/css/app.less";

import React from "react";
import { createRoot } from "react-dom/client";
import AppActions from "./actions/AppActions";
import App from "./components/App";
// Register boot action listeners before AppActions.initialize fires.
import "./boot/accountBoot";

const root = createRoot(document.getElementById("si-app"));
root.render(<App />);

// check for update every 2 minutes
setInterval(
  () => {
    AppActions.checkAppStatus();
  },
  2 * 60 * 1000,
);
